var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"relative",attrs:{"grid-list-xl":""}},[_c('p',{staticClass:"meta font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t("components.lastUpdatedAt.label"))+" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }